export default "__VITE_ASSET__BjRYGyEK__"